import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Map, List } from 'immutable';

import MasterPriceLaddersForm from './MasterPriceLaddersForm.jsx';

class MasterPriceLadder extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {};
    }

    UNSAFE_componentWillReceiveProps(props){
        this.setState({...props})
    }

    onSave(price, oldPrice) {
        let { onSavePrice } = this.props;
        if(onSavePrice && price){
            onSavePrice(price, oldPrice)
        }
    }

    onCreate(price) {
        let {onCreatePrice} = this.props;
        if (price) {
            onCreatePrice && onCreatePrice(price)
        }
    }

    onDelete(price) {
        let {onDeletePrice} = this.props;
        if (onDeletePrice && price) {
            onDeletePrice(price)
        }
    }

    render() {
        let { masterLadder } = this.props;

        return (
            <section className="master-ladder">
                <div className="row">
                    <div className="col-2">Decimal</div>
                    <div className="col-2">Fraction</div>
                </div>

                <MasterPriceLaddersForm createNew={true} onCreate={this.onCreate.bind(this)} />

                {
                    masterLadder && masterLadder.map((item, idx) => {
                        let data = { ...item.toJS() };

                        return (
                            <MasterPriceLaddersForm
                                onSave={this.onSave.bind(this)}
                                onDelete={this.onDelete.bind(this)}
                                data={data}
                                ladder={item}
                                key={idx}
                            />
                        );
                    })
                }

            </section>
        );
    }
}

export default MasterPriceLadder;
